import { alpha, Box, Card, CardActionArea, CardContent, Grid, Stack, Typography } from '@mui/material';
import { coastTheme } from '@vayufp/coast-components';
import { PropsWithChildren, ReactNode } from 'react';

export type ChoiceContainerProps = PropsWithChildren<{
  icon: ReactNode;
  title: ReactNode;
  subtitle: ReactNode;
  onChoice: () => void;
}>;

const CHOICE_ICON_OUTLINE_SIZE = '48px';

const ChoiceContainer: React.FC<ChoiceContainerProps> = ({
  icon,
  title,
  subtitle,
  children,
  onChoice,
}: ChoiceContainerProps) => {
  return (
    <Card variant="outlined">
      <CardActionArea>
        <CardContent sx={{ padding: 3 }}>
          <Grid container spacing={3} alignItems="top" onClick={onChoice} direction="row">
            <Grid item xs={3} display="flex" justifyContent="center">
              <Box
                display="flex"
                height={CHOICE_ICON_OUTLINE_SIZE}
                width={CHOICE_ICON_OUTLINE_SIZE}
                justifyContent="center"
                alignItems="center"
                borderRadius="50%"
                sx={{
                  border: `1px solid ${alpha(coastTheme.palette.text.primary, 0.1)}`,
                }}
              >
                {icon}
              </Box>
            </Grid>
            <Grid item xs={9}>
              <Stack spacing={2}>
                <Typography variant="subtitle1-medium" align="left">
                  {title}
                </Typography>
                <Typography variant="body2" align="left">
                  {subtitle}
                </Typography>
                {children}
              </Stack>
            </Grid>
          </Grid>
        </CardContent>
      </CardActionArea>
    </Card>
  );
};

export { ChoiceContainer };
